import React, { useEffect, useState
} from 'react';
import { useDispatch } from 'react-redux';
import FetchBackend from 'i18next-fetch-backend';
import BackendAdapter from 'i18next-multiload-backend-adapter';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import i18n from '../services/i18n';
import { getLanuageJsonAction } from '@ivymobi/orbit-core/business/share';
import _ from 'lodash';
import Loader from './loaders';
const PreProcess = ({children}) => {
  const [lanunages, setLanuage] = useState([]);
  const dispatch  = useDispatch();
  useEffect(() => {
    const fetchData = async () => {
      const result = await  dispatch(getLanuageJsonAction({}));
      const _languages = _.keyBy(result?.data.filter(i => i.visiable), 'languageid');

      i18n
      // learn more: https://github.com/i18next/i18next-multiload-backend-adapter
      .use(BackendAdapter)
      // detect user language
      // learn more: https://github.com/i18next/i18next-browser-languageDetector
      .use(LanguageDetector)
      // pass the i18n instance to react-i18next.
      .use(initReactI18next)
      // init i18next
      // for all options read: https://www.i18next.com/overview/configuration-options
      .use(FetchBackend).init({
        supportedLngs:Object.keys(_languages),
        // lng: 'zh-CN',
        debug: false,
        ilanguages:result.data.filter(i => i.visiable),
        interpolation: {
          escapeValue: false // not needed for react as it escapes by default
        },
        backend: {
          loadPath: function(lngs, namespaces) {
            return _languages[lngs]?.fileurl;
          }
        },
      }, (err, t) => {
        // 初始化完成后执行的回调函数，此时可以获取所有语言代码（如果有需要）
        setLanuage(result?.data??[]);
      });

    };
    fetchData();
  }, []);

  if (lanunages.length == 0) {
    return <Loader/>;
  }
  return children;
};

export default PreProcess;